/* eslint-disable react/jsx-one-expression-per-line */
import React, { useState, useEffect } from 'react';
import { View, StyleSheet } from 'react-native';
import '../../constants/dateTime.css';
import Flatpickr from 'react-flatpickr';
import CustomText from '../customText/CustomText';
import theme from '../../constants/theme.style.js';

const styles = StyleSheet.create({
  container: {
    flex: 1,
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    marginBottom: 10,
    zIndex: 999,
    fontSize: 30,
  },
  timePickerContainer: {
    backgroundColor: theme.GREEN_DARKER_COLOR,
    padding: 10,
    borderRadius: theme.BUTTON_BORDER_RADIUS,
    justifyContent: 'center',
    alignItems: 'center',
  },
  warning: {
    marginTop: 10,
    color: theme.WHITE_COLOR,
    fontSize: theme.FONT_SIZE_SMALL,
  },
});

const TimePicker = (props) => {
  const { onDateChange } = props;
  const time = new Date();
  time.setHours(time.getHours() + 2);

  const [date, setDate] = useState(time);
  const [showWarning, setShowWarning] = useState(false);

  useEffect(() => {
    onDateChange(time);
  }, []);

  const onChange = (selectedDate) => {
    const now = new Date();
    now.setHours(now.getHours() + 2);
    if (selectedDate[0] < now) {
      setShowWarning(true);
      setDate(now);
    } else {
      setDate(selectedDate);
      setShowWarning(false);
    }

    onDateChange(selectedDate[0]); // change to correct time date format
    // onDateChange(new Date());
  };

  const isToday = () => {
    const someDate = new Date(date);
    const today = new Date();
    return (
      someDate.getDate() === today.getDate() &&
      someDate.getMonth() === today.getMonth() &&
      someDate.getFullYear() === today.getFullYear()
    );
  };

  const getMinTime = () => {
    if (isToday()) {
      const now = new Date();
      now.setHours(now.getHours() + 2);
      const minTime = now.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
      return minTime;
    }
    return '00:00';
  };

  return (
    <View style={styles.container}>
      <View style={styles.timePickerContainer}>
        <Flatpickr
          options={{
            minDate: 'today',
            maxDate: new Date().fp_incr(365),
            inline: true,
            time_24hr: true,
            minTime: getMinTime(),
          }}
          data-enable-time
          value={date}
          onChange={onChange}
          testID="flatpickr"
        />
        {showWarning && (
          <CustomText style={styles.warning}>Message takes at least two hours to arrive</CustomText>
        )}
      </View>
    </View>
  );
};

export default TimePicker;
